import { type StateCreator } from 'zustand';

export type TreeItem = {
  id: string;
  open: boolean;
  touched?: boolean;
};

export type TreeSlice = {
  treeItems: TreeItem[];
  clearTreeItems: () => void;
  setTreeItems: (treeItems: TreeItem[]) => void;
  getTreeItem: (params: { id: string }) => TreeItem | undefined;
  setTreeItem: (params: TreeItem) => void;
  toggleTreeItemOpen: (params: { id: string }) => void;
};

export type CreateTreeSlice = (
  initialState: Pick<Partial<TreeSlice>, 'treeItems'>,
) => StateCreator<TreeSlice, [], [], TreeSlice>;

export const createTreeSlice: CreateTreeSlice = (initialState) => (set, get) => ({
  treeItems: initialState.treeItems ?? [],
  clearTreeItems: () => set({ treeItems: initialState.treeItems ?? [] }),
  setTreeItems: (treeItems) => set({ treeItems }),
  getTreeItem: ({ id }) => get().treeItems.find((item) => item.id === id),
  setTreeItem: ({ id, open, touched }) =>
    set((state) => {
      const treeItem = state.treeItems.find((item) => item.id === id);

      if (treeItem) {
        return {
          treeItems: state.treeItems.map((item) => ({
            ...item,
            open: item.id === id ? open : item.open,
            touched,
          })),
        };
      } else {
        return {
          treeItems: [...state.treeItems, { id, open, touched }],
        };
      }
    }),
  toggleTreeItemOpen: ({ id }) =>
    set((state) => {
      const treeItem = state.treeItems.find((item) => item.id === id);

      if (treeItem) {
        return {
          treeItems: state.treeItems.map((item) => ({
            ...item,
            open: item.id === id ? !item.open : item.open,
            touched: true,
          })),
        };
      } else {
        return {
          treeItems: [...state.treeItems, { id, open: true, touched: true }],
        };
      }
    }),
});
